import _definePage_default_0 from '/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/group/[groupId]/page/[pageId].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/group/[groupId].vue?definePage&vue'
import _definePage_default_3 from '/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/home.vue?definePage&vue'
import _definePage_default_4 from '/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/profile.vue?definePage&vue'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/403',
    name: '/403',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/403.vue'),
    /* no children */
  },
  {
    path: '/404',
    name: '/404',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/404.vue'),
    /* no children */
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/about.vue'),
    /* no children */
  },
  {
    path: '/group',
    /* internal name: '/group' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':groupId',
        name: '/group/[groupId]',
        component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/group/[groupId].vue'),
        children: [
          {
            path: 'page',
            /* internal name: '/group/[groupId]/page' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':pageId',
                name: '/group/[groupId]/page/[pageId]',
                component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/group/[groupId]/page/[pageId].vue'),
                /* no children */
              },
  _definePage_default_0
  )
            ],
          }
        ],
      },
  _definePage_default_2
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/home',
    name: '/home',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/home.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/lost-password',
    name: '/lost-password',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/lost-password.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/profile.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/reset-password',
    name: '/reset-password',
    component: () => import('/srv/nobackup/gitlabrunner/builds/tyu7Co2ve/0/lck/customers/capel/pwa-offline/src/pages/reset-password.vue'),
    /* no children */
  }
]
